import React, { useCallback, useEffect, useState } from "react";

import { CiSearch } from "react-icons/ci";
import { Button, Col, Row, Table } from "react-bootstrap";

import talentUser from "../../assets/images/talent-user.png";
import allTimeHires from "../../assets/images/all-time-hires.png";
import earnings from "../../assets/images/earnings.png";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "../../services/ApiService";
import { ChevronLeft, ChevronRight, User } from "lucide-react";
import Image from "../../components/Image";
import Paginator from "../../components/Paginator";
import Lottie from "lottie-react";
import NoDataAnimation from "../../assets/animations/No Result Green theme.json"
import _ from "lodash";
import { useTranslation } from "react-i18next";
const Dashboard = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
const [refresh, setRefresh] = useState(false)
  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardCountData, setDashboardCountData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    total_pages: 1,
    current_page: 1,
  });
  const [search, setSearch] = useState("");
  const { t, i18n } = useTranslation();
  const statusStyles = {
    Accepted: { bg: "#D3FDEA", color: "#5F8D73" },
    Pending: { bg: "#FEE8D3", color: "#D07B1F" },
    Rejected: { bg: "#FDE3E3", color: "#D15F5F" },
  };

  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    fetchDashboardData(1, search);
  }, [refresh,search]);


  const fetchDashboardData = async (page = 1, searchQuery = "") => {
    try {
      setIsLoading(true);
      const res = await ApiService.request({
        method: "GET",
        url: `getDashboard?page=${page}&search=${encodeURIComponent(searchQuery)}`,
      });

      const data = res.data;
      if (data.status) {
        setDashboardData(data?.data?.active_hires);
        setDashboardCountData(data?.data?.stats);
        setPagination(data?.data?.pagination ? data?.data?.pagination : 1);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      console.error("Fetch Job Error:", err);
      toast.error("Failed to fetch jobs.");
    } finally {
      setIsLoading(false);
    }
  };

    // Debounced function for search input
  const debouncedSearch = useCallback(
    _.debounce((query) => {
      setSearch(query);
    }, 500),
    [] // created only once
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    debouncedSearch(value);
  };
  const handlePageChange = (page) => {
    if (
      page !== pagination.current_page &&
      page >= 1 &&
      page <= pagination.total_pages
    ) {
      fetchDashboardData(page);
    }
  };

  const { current_page, total_pages } = pagination;

  // Generate page numbers (for large datasets show 1,2,3,...,last)
  const getPages = () => {
    const pages = [];

    if (total_pages <= 5) {
      for (let i = 1; i <= total_pages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (current_page > 3) {
        pages.push("...");
      }
      for (
        let i = Math.max(2, current_page - 1);
        i <= Math.min(total_pages - 1, current_page + 1);
        i++
      ) {
        pages.push(i);
      }
      if (current_page < total_pages - 2) {
        pages.push("...");
      }
      pages.push(total_pages);
    }

    return pages;
  };

  const pages = getPages();

  function formatSingleDate(isoDate) {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // or "long" for full month name
    return `${day} ${month}`;
  }
console.log("dashboardCountData", dashboardCountData)
  return (
    <div
      className="inter-font "
      style={
        {
          // height: "100vh",
          // overflowY: "scroll",
          // overflowX: "hidden",
          // scrollbarWidth: "none",
          // msOverflowStyle: "none",
        }
      }
    >
      <div className="inter-font flex-grow-1 px-3 px-md-5 main-bg inp-login">
        {/* Search Input */}
        <div className="inter-font position-relative my-3">
                  {isRTL ?  <CiSearch
                                    className="inter-font position-absolute"
                                    style={{
                                      right: "12px",
                                      top: "50%",
                                      transform: "translateY(-50%) scaleX(-1)",
                                      pointerEvents: "none",
                                    }}
                                    size={20}
                                  /> : null }
          <input
            type="text"
            placeholder={t("c_ff_text65")}
            className={`inter-font w-100 p-2 rounded-3  py-3 ${isRTL ? 'pe-5' : 'ps-5'} `}
            style={{ paddingLeft: "2.5rem", border: "none", fontSize: "14px" }}
            onChange={handleSearchChange}
          />
            {isRTL ? null : <CiSearch
                       className="position-absolute"
                       style={{
                         left: "16px",
                         top: "50%",
                         transform: "translateY(-50%)",
                         color: "#666",
                       }}
                       size={20}
                     />}
        </div>
{/* Stats Cards */}
<div className="inter-font row my-4">
  <div className="inter-font col-12 col-md-4 mb-3">
    
    <div
      className="inter-font card border-0 shadow-sm p-3 rounded-3"
      style={{
        background: "#6D5E2B",
        color: "white",
      }}
    >
      <div 
        className="inter-font d-flex align-items-center gap-3"
        style={{ 
          flexDirection: isRTL ? "row-reverse" : "row"
        }}
      >
        <div
          className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center"
          style={{ width: "50px", height: "50px", minWidth: "50px" }}
        >
          <img
            src={talentUser}
            alt="Dashboard User"
            style={{
              width: "30px",
              height: "30px",
              objectFit: "contain",
            }}
          />
        </div>
        <div style={{ textAlign: isRTL ? "right" : "left" }}>
          <h6
            className="inter-font mb-1 inter-font"
            style={{ fontSize: "15px", fontWeight: 500 }}
          >
            {t("t_d_text2")} {/* Total Views */}
          </h6>
          <h2
            className="inter-font fw-bold mb-0 inter-font"
            style={{ fontSize: "22px", direction: "ltr" }}
          >
            {dashboardCountData?.total_view || 0}
          </h2>
        </div>
      </div>
    </div>
  </div>

  <div className="inter-font col-12 col-md-4 mb-3">
    
    <div
      className="inter-font card border-0 shadow-sm p-3 rounded-3"
      style={{
        background: "#E26A52",
        color: "white",
      }}
    >
      <div 
        className="inter-font d-flex align-items-center gap-3"
        style={{ 
          flexDirection: isRTL ? "row-reverse" : "row"
        }}
      >
        <div
          className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center"
          style={{ width: "50px", height: "50px", minWidth: "50px" }}
        >
          <img
            src={allTimeHires}
            alt="Dashboard User"
            style={{
              width: "30px",
              height: "30px",
              objectFit: "contain",
            }}
          />
        </div>
        <div style={{ textAlign: isRTL ? "right" : "left" }}>
          <h6
            className="inter-font mb-1 inter-font"
            style={{ fontSize: "15px", fontWeight: 500 }}
          >
            {t("t_d_text3")} {/* Total Jobs */}
          </h6>
          <h2
            className="inter-font fw-bold mb-0 inter-font"
            style={{ fontSize: "22px", direction: "ltr" }}
          >
            {dashboardCountData?.total_jobs || 0}
          </h2>
        </div>
      </div>
    </div>
  </div>

  <div className="inter-font col-12 col-md-4 mb-3">
    
    <div
      className="inter-font card border-0 shadow-sm p-3 rounded-3"
      style={{
        background: "#AF516F",
        color: "white",
      }}
    >
      <div 
        className="inter-font d-flex align-items-center gap-3"
        style={{ 
          flexDirection: isRTL ? "row-reverse" : "row"
        }}
      >
        <div
          className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center"
          style={{ width: "50px", height: "50px", minWidth: "50px" }}
        >
          <img
            src={earnings}
            alt="Dashboard User"
            style={{
              width: "30px",
              height: "30px",
              objectFit: "contain",
            }}
          />
        </div>
        <div style={{ textAlign: isRTL ? "right" : "left" }}>
          <h6
            className="inter-font mb-1 inter-font"
            style={{ fontSize: "15px", fontWeight: 500 }}
          >
            {t("t_d_text6")} {/* Total Earnings */}
          </h6>
          <h2
            className="inter-font fw-bold mb-0 inter-font"
            style={{ fontSize: "22px", direction: "ltr" }}
          >
            {dashboardCountData?.total_earnings || 0} AED
          </h2>
        </div>
      </div>
    </div>
  </div>

  {/* Active Project */}
  <div className="inter-font col-12 col-md-4 mb-3">
    
    <div className="inter-font card border-0 shadow-sm p-3 rounded-3" style={{ background: "#CD496D", color: "white" }}>
      <div className="inter-font d-flex align-items-center gap-3" style={{ flexDirection: isRTL ? "row-reverse" : "row" }}>
         <div className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px", minWidth: "50px" }}>
          <img src={allTimeHires} alt={t("ui_active_project")} style={{ width: "30px", height: "30px", objectFit: "contain" }} />
        </div>
        <div style={{ textAlign: isRTL ? "right" : "left" }}>
          <h6 className="inter-font mb-1 inter-font" style={{ fontSize: "15px", fontWeight: 500 }}>{t("ui_active_project")}</h6>
          <h2 className="inter-font fw-bold mb-0 inter-font" style={{ fontSize: "22px", direction: "ltr" }}>{dashboardCountData?.active_projects || 0}</h2>
        </div>
      </div>
    </div>
  </div>

  {/* Rejected Project */}
  <div className="inter-font col-12 col-md-4 mb-3">
    
    <div className="inter-font card border-0 shadow-sm p-3 rounded-3" style={{ background: "#D15F5F", color: "white" }}>
      <div className="inter-font d-flex align-items-center gap-3" style={{ flexDirection: isRTL ? "row-reverse" : "row" }}>
        <div className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px", minWidth: "50px" }}>
          <img src={allTimeHires} alt={t("ui_rejected_project")} style={{ width: "30px", height: "30px", objectFit: "contain" }} />
        </div>
        <div style={{ textAlign: isRTL ? "right" : "left" }}>
          <h6 className="inter-font mb-1 inter-font" style={{ fontSize: "15px", fontWeight: 500 }}>{t("ui_rejected_project")}</h6>
          <h2 className="inter-font fw-bold mb-0 inter-font" style={{ fontSize: "22px", direction: "ltr" }}>{dashboardCountData?.rejected_projects || 0}</h2>
        </div>
      </div>
    </div>
  </div>

  {/* Pending Project */}
  <div className="inter-font col-12 col-md-4 mb-3">
    
    <div className="inter-font card border-0 shadow-sm p-3 rounded-3" style={{ background: "#D07B1F", color: "white" }}>
      <div className="inter-font d-flex align-items-center gap-3" style={{ flexDirection: isRTL ? "row-reverse" : "row" }}>
        <div className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px", minWidth: "50px" }}>
          <img src={allTimeHires} alt={t("ui_pending_project")} style={{ width: "30px", height: "30px", objectFit: "contain" }} />
        </div>
        <div style={{ textAlign: isRTL ? "right" : "left" }}>
          <h6 className="inter-font mb-1 inter-font" style={{ fontSize: "15px", fontWeight: 500 }}>{t("ui_pending_project")}</h6>
          <h2 className="inter-font fw-bold mb-0 inter-font" style={{ fontSize: "22px", direction: "ltr" }}>{dashboardCountData?.pending_projects || 0}</h2>
        </div>
      </div>
    </div>
  </div>

  {/* Accepted Project */}
  <div className="inter-font col-12 col-md-4 mb-3">
    
    <div className="inter-font card border-0 shadow-sm p-3 rounded-3" style={{ background: "#5F8D73", color: "white" }}>
      <div className="inter-font d-flex align-items-center gap-3" style={{ flexDirection: isRTL ? "row-reverse" : "row" }}>
        <div className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px", minWidth: "50px" }}>
          <img src={allTimeHires} alt={t("ui_accepted_project")} style={{ width: "30px", height: "30px", objectFit: "contain" }} />
        </div>
        <div style={{ textAlign: isRTL ? "right" : "left" }}>
          <h6 className="inter-font mb-1 inter-font" style={{ fontSize: "15px", fontWeight: 500 }}>{t("ui_accepted_project")}</h6>
          <h2 className="inter-font fw-bold mb-0 inter-font" style={{ fontSize: "22px", direction: "ltr" }}>{dashboardCountData?.accepted_projects || 0}</h2>
        </div>
      </div>
    </div>
  </div>

  {/* Completed */}
  <div className="inter-font col-12 col-md-4 mb-3">
    
    <div className="inter-font card border-0 shadow-sm p-3 rounded-3" style={{ background: "#4285F4", color: "white" }}>
      <div className="inter-font d-flex align-items-center gap-3" style={{ flexDirection: isRTL ? "row-reverse" : "row" }}>
        <div className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px", minWidth: "50px" }}>
          <img src={allTimeHires} alt={t("ui_completed")} style={{ width: "30px", height: "30px", objectFit: "contain" }} />
        </div>
        <div style={{ textAlign: isRTL ? "right" : "left" }}>
          <h6 className="inter-font mb-1 inter-font" style={{ fontSize: "15px", fontWeight: 500 }}>{t("ui_completed")}</h6>
          <h2 className="inter-font fw-bold mb-0 inter-font" style={{ fontSize: "22px", direction: "ltr" }}>{dashboardCountData?.completed_projects || 0}</h2>
        </div>
      </div>
    </div>
  </div>

</div>

        {/* Hire Projects Table */}
        <div>
          <h5
            className="inter-font mb-3 inter-font"
            style={{ fontSize: "16px", textAlign: isRTL ? "right" : "left" }}
          >
            {t("t_d_text7")} {/* Hire Projects */}
          </h5>
          <div
            className="inter-font bg-white rounded-3 p-3 shadow"
            style={{ overflowX: "auto", width: "100%" }}
          >
            {isLoading ? (
              <div className="inter-font d-flex justify-content-center py-5">
                <div className="inter-font spinner-border" role="status"></div>
              </div>
            ) : dashboardData?.length !== 0 ? (
              <div
                className="table-responsive inter-font"
                style={{
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                }}
              >
                <table
                  className="inter-font table align-middle mb-0 table-hover"
                  style={{
                    minWidth: "900px",
                    direction: isRTL ? "rtl" : "ltr",
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text79")}
                      </th>{" "}
                      {/* Employe Company */}
                      <th style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text80")}
                      </th>{" "}
                      {/* Contract Type */}
                      <th style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text81")}
                      </th>{" "}
                      {/* Start Date */}
                      <th style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text82")}
                      </th>{" "}
                      {/* End Date */}
                      <th style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text83")}
                      </th>{" "}
                      {/* Status */}
                      <th style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text84")}
                      </th>{" "}
                      {/* Project Name */}
                      <th style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text85")}
                      </th>{" "}
                      {/* Amount */}
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData.map((item, index) => (
                      <tr key={index} className="cursor-pointer"
                        onClick={() => navigate("/talent/project-details", { state: { project: item} }) }>
                        <td style={{ textAlign: isRTL ? "right" : "left" }}>
                          <div
                            className="inter-font d-flex align-items-center gap-2"
                            style={{
                              flexDirection: isRTL ? "row-reverse" : "row",
                              justifyContent: isRTL ? "flex-end" : "flex-start",
                            }}
                          >
                            <Image
                              src={item?.project_id.company_id.logo}
                              alt="logo"
                              className="rounded-circle"
                              style={{
                                width: "40px",
                                height: "40px",
                                objectFit: "cover",
                                [isRTL ? "marginLeft" : "marginRight"]: "8px",
                              }}
                            />
                            <span
                              className="inter-font inter-font"
                              style={{
                                color: "#959595",
                                textAlign: isRTL ? "right" : "left",
                              }}
                            >
                              {item.project_id.company_id
                                ? item.project_id.company_id.company_name
                                : "-"}
                            </span>
                          </div>
                        </td>
                        <td
                          style={{
                            color: "#959595",
                            textAlign: isRTL ? "right" : "left",
                            direction: "ltr",
                          }}
                        >
                          {item.job_type ? item.job_type : "-"}
                        </td>
                        <td
                          style={{
                            color: "#959595",
                            textAlign: isRTL ? "right" : "left",
                            direction: "ltr",
                          }}
                        >
                          {item.start_date
                            ? formatSingleDate(item.start_date)
                            : "N/A"}
                        </td>
                        <td
                          style={{
                            color: "#959595",
                            textAlign: isRTL ? "right" : "left",
                            direction: "ltr",
                          }}
                        >
                          {item.end_date
                            ? formatSingleDate(item.end_date)
                            : "N/A"}
                        </td>
                        <td
                          style={{
                            fontWeight: 500,
                            textAlign: isRTL ? "right" : "left",
                            direction: "ltr",
                          }}
                        >
                          <span className="badge" style={{
                            color: statusStyles[item.status]?.color || "#959595",
                            backgroundColor: statusStyles[item.status]?.bg || "#FDE3E3",
                          }}>
                          {item.status ? item.status : "-"}
                          {item.status === 'Accepted' &&
                            <span className="ms-2" style={{ fontSize: "13px", fontWeight: "500", direction: "ltr" }}>
                              ({ item.payment_status === "Pending" ? t("in_progress") : t("hired")})
                            </span>
                          }
                          </span>
                        </td>
                        <td
                          style={{
                            color: "#959595",
                            maxWidth: "150px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            textAlign: isRTL ? "right" : "left",
                            direction: "ltr",
                          }}
                        >
                          {item?.project_id?.title
                            ? item.project_id.title
                                .split(" ")
                                .slice(0, 3)
                                .join(" ") +
                              (item.project_id.title.split(" ").length > 3
                                ? "..."
                                : "")
                            : "-"}
                        </td>
                        <td
                          style={{
                            color: "#959595",
                            textAlign: isRTL ? "right" : "left",
                            direction: "ltr",
                          }}
                        >
                          {item.total_amount ? `${item.total_amount} AED` : "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="d-flex flex-column align-items-center py-5">
                <div style={{ width: 200 }}>
                  <Lottie animationData={NoDataAnimation} loop={true} />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Pagination */}
        {pagination?.total_pages > 1 && (
          <Paginator
            page={pagination.current_page}
            rows={pagination.per_page}
            totalRecords={pagination.total_records}
            onPageChange={handlePageChange}
          />
        )}

        <div style={{ height: "30px" }}></div>
      </div>
    </div>
  );
};

export default Dashboard;
